import type { JSX } from 'react';

import { CaretDownIcon, CaretUpIcon, CheckmarkVerifiedIcon } from '@change/ds-icons';

import { Accordion, Text } from '@change/ds-core-ui/next';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';

import {
	usePetitionDetailsPageData,
	usePetitionDetailsPageUserData,
} from 'src/app/pages/petitionGamma/details/pageContext';
import { useCampaignTracking } from 'src/app/shared/hooks/campaignTracking';

import { usePetitionSignatureCount } from '../../../hooks/petitionStats';

import { SignatureThermometer } from './SignatureThermometer';

export function SignatureStatsActiveContainer(): JSX.Element {
	const { signatureCount, signatureGoal } = usePetitionSignatureCount();
	const { track } = useCampaignTracking();
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();

	const onToggle = (isExpanded: boolean) => {
		const trackingData = {
			petition_id: id,
			opened: isExpanded,
		};

		track('campaign_action_show_verified_signers_text_click', trackingData);
	};

	const {
		data: { signatureThermometerEnabled },
	} = usePetitionDetailsPageUserData();

	const signatureThermometerConditionalRenderingEnabled =
		signatureThermometerEnabled && signatureCount.displayed < 1000;

	return (
		<div>
			<div className="mb-2 flex flex-col items-center justify-center gap-2">
				<div className="flex flex-row gap-1">
					<Text as="h2" variant="heading" size="large">
						{signatureCount.displayedLocalized}
					</Text>

					<CheckmarkVerifiedIcon className="text-icon-accent-primary" size="small" />
				</div>
			</div>
			<Accordion
				variant="un-contained"
				headingClassName="justify-center text-center my-0"
				className="justify-center text-center"
				data-testid="verified-signatures-toggle-text"
				title={
					<TranslatePlural
						value="corgi.petition_gamma.details.verified_signers_text.title"
						count={signatureCount.displayed}
					/>
				}
				onToggle={(_event, expanded) => onToggle(expanded)}
				collapseIcon={<CaretDownIcon />}
				expandIcon={<CaretUpIcon />}
			>
				<Text className="text-center italic text-content-primary" size="small" data-testid="verified-signatures-text">
					<Translate value="corgi.petition_gamma.details.verified_signers_text.body" />
				</Text>
			</Accordion>

			{signatureThermometerConditionalRenderingEnabled && (
				<SignatureThermometer signatureCount={signatureCount.displayed} nextMilestone={signatureGoal.displayed} />
			)}
		</div>
	);
}
